import * as angular from 'angular';

export class HaEmployeeFactory {
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    readMe() {
        return this.$http.get(`/api/v2/me/`);
    }
}

angular
    .module('app')
    .service('HaEmployeeFactory', HaEmployeeFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/ha_employee.factory.ts